var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardDetailCalander(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 0.833344V2.50001H12.4998V0.833344H14.1665V2.50001H17.4998C17.9601 2.50001 18.3332 2.87311 18.3332 3.33334V16.6667C18.3332 17.1269 17.9601 17.5 17.4998 17.5H2.49984C2.0396 17.5 1.6665 17.1269 1.6665 16.6667V3.33334C1.6665 2.87311 2.0396 2.50001 2.49984 2.50001H5.83317V0.833344H7.49984ZM16.6665 9.16668H3.33317V15.8333H16.6665V9.16668ZM6.6665 10.8333V12.5H4.99984V10.8333H6.6665ZM10.8332 10.8333V12.5H9.1665V10.8333H10.8332ZM14.9998 10.8333V12.5H13.3332V10.8333H14.9998ZM5.83317 4.16668H3.33317V7.50001H16.6665V4.16668H14.1665V5.83334H12.4998V4.16668H7.49984V5.83334H5.83317V4.16668Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardDetailCalander);
export default __webpack_public_path__ + "static/media/rewardDetailCalander.c4dcf76c281a45414f9e85ef490cad11.svg";
export { ForwardRef as ReactComponent };